import {IUserAccount} from "../interfaces/user";
export class UserAccount implements IUserAccount {
  public phonenumber : string;
  public verified : boolean = false;

  constructor(payload : IUserAccount){
    this.phonenumber = payload.phonenumber;
    this.verified = payload.verified;
  }

  static create(payload : IUserAccount){
    const opts = {
      "phonenumber": "",
      "verified" : false
    }
    return new UserAccount(Object.assign(opts, payload));
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/user_account.ts